module.exports = __webpack_public_path__ + "static/grzesiak_entire_page_2-15340f9ca109d6c390224799a60f83d0.jpg";